import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  dateField,
  repeatableSection,
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { getAddressFields } from 'app/modules/goAML/formConfig/fields/addressFields';
import { getIdentificationFields } from 'app/modules/goAML/formConfig/fields/identificationFields';
import { getPhoneFields } from 'app/modules/goAML/formConfig/fields/phoneFields';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

export const getPersonRawFields = (
  referenceTables: GoamlReferenceTables,
  opts?: { myClient?: boolean },
): FormFields<FieldValues> => {
  const myClient = opts?.myClient ?? false;

  return [
    selectField(
      { name: 'gender', label: 'Gender', refTable: 'gender' },
      referenceTables,
    ),
    textField({ name: 'title', label: 'Title' }),
    textField({ name: 'first_name', label: 'First name', required: true }),
    textField({ name: 'middle_name', label: 'Middle name' }),
    textField({ name: 'last_name', label: 'Last name', required: true }),
    dateField({ name: 'birthdate', label: 'Birth date', required: myClient }),
    textField({ name: 'birth_place', label: 'Birth place' }),
    textField({ name: 'mothers_name', label: "Mother's name" }),
    textField({ name: 'alias', label: 'Alias' }),
    textField({ name: 'ssn', label: 'SSN' }),
    textField({ name: 'passport_number', label: 'Passport number' }),
    selectField(
      {
        name: 'passport_country',
        label: 'Passport country',
        refTable: 'country_code',
      },
      referenceTables,
    ),
    textField({ name: 'id_number', label: 'ID number', required: myClient }),
    selectField(
      {
        name: 'nationality1',
        label: 'Nationality 1',
        required: myClient,
        refTable: 'country_code',
      },
      referenceTables,
    ),
    selectField(
      {
        name: 'nationality2',
        label: 'Nationality 2',
        refTable: 'country_code',
      },
      referenceTables,
    ),
    selectField(
      {
        name: 'nationality3',
        label: 'Nationality 3',
        refTable: 'country_code',
      },
      referenceTables,
    ),
    selectField(
      {
        name: 'residence',
        label: 'Residence',
        required: myClient,
        refTable: 'country_code',
      },
      referenceTables,
    ),
    textField({ name: 'email', label: 'Email' }),
    textField({ name: 'occupation', label: 'Occupation' }),
    textField({ name: 'employer_name', label: 'Employer name' }),
    selectField({
      name: 'deceased',
      label: 'Deceased?',
      options: [
        { value: '0', text: 'No' },
        { value: '1', text: 'Yes' },
      ],
    }),
    dateField({ name: 'date_deceased', label: 'Date deceased' }),
    textField({ name: 'tax_number', label: 'Tax number' }),
    textField({ name: 'tax_reg_number', label: 'Tax registration number' }),
    textField({ name: 'source_of_wealth', label: 'Source of wealth' }),
    textareaField({ name: 'comments', label: 'Comments' }),
  ];
};

export const getPersonTransactionFields = (
  referenceTables: GoamlReferenceTables,
  opts?: { myClient?: boolean },
): FormFields<FieldValues> => [
  ...getPersonRawFields(referenceTables, opts),
  repeatableSection({
    name: 'phones',
    label: 'Phones',
    fields: getPhoneFields(referenceTables),
  }),
  repeatableSection({
    name: 'identification',
    label: 'Identifications',
    fields: getIdentificationFields(referenceTables),
  }),
  repeatableSection({
    name: 'addresses',
    label: 'Addresses',
    fields: getAddressFields(referenceTables),
  }),
];
